export default {
    dependencies: ['$element', 'xhrservice'],
    callable(ele, xhr) {
        const storageKey = 'searchItems';

        init();

        function init() {
            const pagingData = load();
            if (pagingData && pagingDataAppliesToCurrentAd(pagingData)) {
                updateLinks(pagingData);
                ele.classList.remove('invisible');
                ele.style.visibility = ''; // Troika does not have a class for this
                document.addEventListener('keydown', handleKeydown);
                maybeFetchMoreUrls(pagingData);
            }
        }

        function updateLinks(pagingData) {
            const [prev, next] = pagingLinks(pagingData);
            if (pagingData.newFhh) {
                ele.querySelector('[rel=prev]').classList.add('invisible');
                ele.querySelector('[rel=next]').classList.add('invisible');
            }
            ele.querySelector('[rel=prev]').href = prev || pagingData.search;
            ele.querySelector('[rel=next]').href = next || pagingData.search;
            ele.querySelector('[rel=start]').href = pagingData.search;
            return pagingData;
        }

        function maybeFetchMoreUrls(pagingData) {
            const thisIndex = pagingData.urls.indexOf(
                window.location.pathname + window.location.search
            );
            let searchResultPromise;
            if (thisIndex < 3 && pagingData.prev) {
                searchResultPromise = pagingDataPromise(pagingData.prev).then(
                    prependBefore(pagingData)
                );
            } else if (
                thisIndex + 3 > pagingData.urls.length &&
                pagingData.next
            ) {
                searchResultPromise = pagingDataPromise(pagingData.next).then(
                    appendAfter(pagingData)
                );
            }
            if (searchResultPromise) {
                searchResultPromise
                    .then(removeDupes)
                    .then(updateLinks)
                    .then(save);
            }
        }

        function pagingDataPromise(url) {
            return xhr.getJson(url).then(searchResultToPagingData);
        }

        function searchResultToPagingData(res) {
            return {
                urls: res.displaySearchResults
                    .filter(e => !e.isBanner)
                    .map(e => e.adUrl),
                next:
                    res.nextResult &&
                    res.nextResult.url.replace('.html', '.json'),
                prev:
                    res.prevResult &&
                    res.prevResult.url.replace('.html', '.json'),
            };
        }

        function removeDupes(pagingData) {
            pagingData.urls = uniqWith(getAdIdFromUrl, pagingData.urls);
            return pagingData;
        }

        function getAdIdFromUrl(url) {
            return new URL(url, document.baseURI).searchParams.get('finnkode');
        }

        function getThisIndex(pagingData) {
            return pagingData.urls.indexOf(
                window.location.pathname + window.location.search
            );
        }

        function pagingDataAppliesToCurrentAd(pagingData) {
            return pagingData ? getThisIndex(pagingData) !== -1 : false;
        }

        function pagingLinks(pagingData) {
            const thisIndex = getThisIndex(pagingData);
            return thisIndex === -1
                ? []
                : [
                      pagingData.urls[thisIndex - 1],
                      pagingData.urls[thisIndex + 1],
                  ];
        }

        function prependBefore(oldData) {
            return function(newData) {
                oldData.prev = newData.prev;
                oldData.urls = newData.urls.concat(oldData.urls);
                return oldData;
            };
        }

        function appendAfter(oldData) {
            return function(newData) {
                oldData.next = newData.next;
                oldData.urls = oldData.urls.concat(newData.urls);
                return oldData;
            };
        }

        function uniqWith(keyFun, array) {
            const seen = [];
            const ret = [];
            let key;
            for (let n = 0; n < array.length; n++) {
                key = keyFun(array[n]);
                if (seen.indexOf(key) === -1) {
                    seen.push(key);
                    ret.push(array[n]);
                }
            }
            return ret;
        }

        function load() {
            try {
                const data = JSON.parse(
                    window.sessionStorage.getItem(storageKey)
                );
                return data && data.urls && data.search ? data : null;
            } catch (e) {
                return null;
            } // ignore session storage missing or incognito mode
        }

        function save(data) {
            try {
                window.sessionStorage.setItem(storageKey, JSON.stringify(data));
            } catch (e) {
                return null;
            } // ignore session storage missing or incognito mode
        }

        function handleKeydown(event) {
            if (event.target.closest('input, textarea')) {
                return;
            }

            if (
                event.keyCode === 39 /* Right Arrow */ &&
                (event.metaKey || event.altKey) &&
                !event.shiftKey &&
                !event.ctrlKey
            ) {
                // Normally, Alt/Cmd-RightArrow navigates forward. If there's
                // no forward history, navigate to the next item.
                // Wait 100 ms and assume navigation has happened.
                window.setTimeout(() => {
                    ele.querySelector('[rel=next]').click();
                }, 100);
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/adPaging.js